import { cva, type VariantProps } from "./cva.ts"

export const Link = ({ className, underline = true, ...props }: Link.Props) => (
  <a className={classForLink({ underline, className })} {...props} />
)

export const classForLink = cva(
  [
    "inline-flex gap-0.5 items-center justify-center flex-grow-0",
    "text-sm text-gray-12 select-none",
    "transition-colors",
    "decoration-gray-7 hover:decoration-gray-12",
    "hover:text-gray-12 hover:cursor-pointer",
    "focus-visible:text-gray-12 focus-visible:decoration-gray-12",
    "active:text-gray-11 active:decoration-gray-11",
    "disabled:text-gray-8 disabled:decoration-gray-8 disabled:pointer-events-none",
  ],
  {
    variants: {
      underline: {
        true: "underline underline-offset-4",
        false: "no-underline hover:underline",
      },
    },
    defaultVariants: {
      underline: true,
    },
  },
)

export namespace Link {
  export type Props = React.ComponentProps<"a"> & VariantProps<typeof classForLink>
}
